module.exports = __webpack_public_path__ + "static/media/techtimeless.fbed5939.webp";